import { render } from "./ContentArea.vue?vue&type=template&id=95a118e8&scoped=true"
import script from "./ContentArea.vue?vue&type=script&lang=js"
export * from "./ContentArea.vue?vue&type=script&lang=js"

import "./ContentArea.vue?vue&type=style&index=0&id=95a118e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95a118e8"]])

export default __exports__